import { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { readApiError } from '../lib/apiError';

export interface MembershipSummary {
  membershipId: string;
  orgId: string;
  orgName: string;
  orgSlug: string;
  orgType: string;
  orgRoles: string[];
  joinedAt: number;
  isActive: boolean;
}

const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8080';

export function useMemberships(refreshKey: number | string = 0) {
  const { session } = useAuth();
  const [memberships, setMemberships] = useState<MembershipSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!session) return;
    let cancelled = false;
    (async () => {
      try {
        const idToken = await session.user.getIdToken();
        const res = await fetch(`${API_URL}/v1/me/memberships`, {
          headers: { authorization: `Bearer ${idToken}` },
        });
        if (!res.ok) throw await readApiError(res);
        const body = (await res.json()) as { memberships: MembershipSummary[] };
        if (!cancelled) setMemberships(body.memberships);
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err.message : String(err));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [session?.uid, session?.activeOrgId, refreshKey]);

  return { memberships, error };
}
